import React from 'react';
import Icon from '~/UI/Icon/Icon';

import defaultStyles from './default.less';

export enum Status {
	saving = 'saving',
	saved = 'saved',
	failed = 'failed',
}

export const Statuses = Status;

export type Props = {
	status: Status | null;
	hideAfterMilliseconds: number;
	savingContent: React.ReactNode;
	savedContent: React.ReactNode;
	styles: { badge: string; hiddenBadge: string };
	testId?: string;
};

const resolveVisibility = (status: Props['status']) => {
	switch (status) {
		case null:
			return false;

		case Statuses.saving:
			return true;

		case Statuses.saved:
			return true;

		case Statuses.failed:
			return false;
	}
};

const SaveActivityIndicatorAsFunction = (props: Props) => {
	const { status, savingContent, savedContent, styles, hideAfterMilliseconds, testId } = props;
	const [visible, setVisible] = React.useState(resolveVisibility(status));

	React.useEffect(() => {
		setVisible(resolveVisibility(status));

		const timeoutId = setTimeout(() => {
			setVisible(status !== Statuses.saved);
		}, hideAfterMilliseconds);

		return () => clearTimeout(timeoutId);
	}, [status, hideAfterMilliseconds, testId]);

	return (
		<div className={visible ? styles.badge : styles.hiddenBadge} data-testid={testId}>
			{status === Statuses.saving && savingContent}
			{status === Statuses.saved && savedContent}
		</div>
	);
};

SaveActivityIndicatorAsFunction.defaultProps = {
	status: null,
	hideAfterMilliseconds: undefined,
	savingContent: (
		<>
			<Icon name='spinner' />
			Saving…
		</>
	),
	savedContent: (
		<>
			<Icon name='saved' />
			Saved!
		</>
	),
	styles: defaultStyles,
};

export default SaveActivityIndicatorAsFunction;
